module.exports = __webpack_public_path__ + "img/nt110-01-81-1.prt.045b2f20.jpg";